import { render, staticRenderFns } from "./OrderNotesForm.vue?vue&type=template&id=52a0abf2&scoped=true"
import script from "./OrderNotesForm.vue?vue&type=script&lang=ts"
export * from "./OrderNotesForm.vue?vue&type=script&lang=ts"
import style0 from "./OrderNotesForm.vue?vue&type=style&index=0&id=52a0abf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a0abf2",
  null
  
)

export default component.exports